import Vue from 'vue';
import Vuex from 'vuex';
import user from './modules/user';
import folder from './modules/folder';
import mail from './modules/mail';
import address from './modules/address';
import getters from './getters';

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    user,
    folder,
    mail,
    address
  },
  getters
});

export default store



// WEBPACK FOOTER //
// ./src/store/index.js